import { render, staticRenderFns } from "./InviteDialog.vue?vue&type=template&id=f332c580"
import script from "./InviteDialog.vue?vue&type=script&lang=js"
export * from "./InviteDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteDialog.vue?vue&type=style&index=0&id=f332c580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports